import store from "../store";

/**
 * Don't go anywhere until determining if a user is logged in or not
 *
 * Needed so the route guards trigger correctly on initial page load
 */
export function firstTimeGuard(to, from, next) {
    if (store.state.loaded !== null) {
        next();
        return;
    }

    let requirements = [];

    //Insure that parent routes that require something don't have to define it on all their children
    const nearestWithRequires = to.matched.slice().reverse().find(r => r.meta && r.meta.requires);
    if (nearestWithRequires) {
        requirements = nearestWithRequires.meta.requires;
    }

    (async () => {
        await store.dispatch('doInitialLoad', requirements);
        next();
    })();
}

/**
 * A guard to make sure the user has the appropriate permissions to access a page
 *
 * WARNING:  Always secure the API, and never rely on this for anything other than UX.
 */
export function permissionsGuard(to, from, next) {
    if (!to.meta) {
        next();
        return;
    }

    switch (to.meta.permission) {
        case 'user':  //The user is logged in
            if (!store.getters['user/isLoggedIn']) {
                let nextQuery = to.path;
                next({name: 'home', query: {'next': nextQuery}});
                return;
            }
            break;
        case 'staff':  //The user is a member of HEAT
            //Todo:  Refactor this to remove duplicate code
            if (!store.getters['user/isLoggedIn']) {
                let nextQuery = to.path;
                next({name: 'home', query: {'next': nextQuery}});
                return;
            }
            if (!store.state.user.isStaff) {
                next({name: 'not-found'});
                return;
            }
            break;
    }
    next();
}

/**
 * This simply sets the title based on a route's meta information
 * See Here: https://alligator.io/vuejs/vue-router-modify-head/
 *
 * Not using breadcrumbs because those are modified during runtime and may be stale.
 */
export function setTitleGuard(to, from, next) {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    }

    next();
}
